import React from 'react';
import { Bar, CartesianGrid, ComposedChart, Legend, Line, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { Spinner } from 'components/UI';
import { VelocityData } from '../../data/mockData';
import styles from './ClientMovementChart.module.scss';

interface ClientMovementChartProps {
    movement: VelocityData['movement'];
    loading: boolean;
}

export const ClientMovementChart: React.FC<ClientMovementChartProps> = props => {
    if (props.loading) {
        return (
            <div className={styles.loadingWrap}>
                <Spinner />
            </div>
        );
    }

    return (
        <ResponsiveContainer
            width="100%"
            height={280}
        >
            <ComposedChart
                data={props.movement}
                margin={{ top: 8, right: 8, bottom: 0, left: 0 }}
                stackOffset="sign"
            >
                <CartesianGrid
                    vertical={false}
                    stroke="#F1F1F1"
                />
                <XAxis
                    dataKey="month"
                    tick={{ fontSize: 12, fontFamily: 'Poppins' }}
                    axisLine={false}
                    tickLine={false}
                />
                <YAxis
                    yAxisId="movement"
                    tick={{ fontSize: 12, fontFamily: 'Poppins' }}
                    axisLine={false}
                    tickLine={false}
                />
                <YAxis
                    yAxisId="active"
                    orientation="right"
                    tick={{ fontSize: 12, fontFamily: 'Poppins' }}
                    axisLine={false}
                    tickLine={false}
                />
                <Tooltip
                    formatter={(value: number, name: string) => [name === 'Lost' ? Math.abs(value) : value, name]}
                    contentStyle={{ fontFamily: 'Poppins', fontSize: 12, borderRadius: 8 }}
                />
                <Legend wrapperStyle={{ fontFamily: 'Poppins', fontSize: 12 }} />
                <Bar
                    yAxisId="movement"
                    dataKey="gained"
                    name="New clients"
                    stackId="movement"
                    fill="#5E8677"
                    radius={[4, 4, 0, 0]}
                    barSize={22}
                />
                <Bar
                    yAxisId="movement"
                    dataKey="lost"
                    name="Lost"
                    stackId="movement"
                    fill="#EF4F57"
                    radius={[0, 0, 4, 4]}
                    barSize={22}
                />
                <Line
                    yAxisId="active"
                    type="monotone"
                    dataKey="netActive"
                    name="Active clients"
                    stroke="#C18733"
                    strokeWidth={2}
                    dot={{ r: 3 }}
                />
            </ComposedChart>
        </ResponsiveContainer>
    );
};

export default ClientMovementChart;
